__turbopack_context__.v({
  "count": "SimulatorCompetitionList-module__sN7eBW__count",
  "filters": "SimulatorCompetitionList-module__sN7eBW__filters",
});
